import {findIndex, isArray, map, sortBy} from 'underscore'
import * as mutationTypes from './mutation-types'
import modules from './modules'

const namespaced = true

const initialState = () => ({
    cards: [],
    loading: true,
    wallboard: {
        uuid: '',
        name: ''
    }
})

const state = initialState()

const getters = {
    wallboard: state => state.wallboard,
    wallboardUuid: state => state.wallboard.uuid,
    wallboardName: state => state.wallboard.name,
    wallboardCards: state => sortBy(state.cards, 'order_id'),
    wallboardLoading: state => state.loading
}

const actions = {
    resetWallboard: ({commit}) => commit(mutationTypes.RESET_WALLBOARD),
    setWallboard: ({commit}, data) => commit(mutationTypes.SET_WALLBOARD, data)
}

const mutations = {
    [mutationTypes.RESET_WALLBOARD]: state => Object.assign(state, initialState()),
    [mutationTypes.SET_WALLBOARD]: (state, data) => {
        state.loading = false
        state.wallboard = data
    },
    [mutationTypes.SET_WALLBOARD_CARDS]: (state, data) => state.cards = data,
    [mutationTypes.UPDATE_WALLBOARD_CARDS]: (state, data) => {
        if (!isArray(data)) {
            return
        }

        state.cards = map(state.cards, card => {
            const index = findIndex(data, {uuid: card.uuid})
            const cardUpdate = index !== -1
                ? data[index]
                : {}

            return {...card, ...cardUpdate}
        })
    }
}

export default {
    namespaced,
    state,
    modules,
    mutations,
    actions,
    getters
}
